
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { RestaurantFormData } from "@/types/restaurantForm";

interface EmailFieldProps {
  form: UseFormReturn<RestaurantFormData>;
}

export const EmailField = ({ form }: EmailFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="contact_email"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-2">
            Contact Email
            <span className="text-sm text-muted-foreground">(Optional)</span>
          </FormLabel>
          <FormControl>
            <Input {...field} type="email" placeholder="contact@restaurant.com" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
